import _ from 'lodash';

export const addFormProps = searchCriteria => _.transform(searchCriteria, (result, value, key) => {
    result[key] = {
        value,
        original: value,
        touched: false
    };
}, {});

export const setValue = (state, value) => _.assign({}, state, {
    value,
    touched: true
});